import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { RhRawButton } from './RhRawButton';

type Props = {
  trigger: React.ReactNode;
};

/**
 * References
 * Outside click: https://medium.com/@pitipatdop/little-neat-trick-to-capture-click-outside-with-react-hook-ba77c37c7e82
 * @param props
 * @returns
 */
export const RhDropdown: React.FC<Props> = props => {
  const node = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleClick = (e: any) => {
    if (node.current?.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [open]);

  return (
    <Container ref={node}>
      <RhRawButton onClick={() => setOpen(!open)}>{props.trigger}</RhRawButton>
      {open && <Drop>{props.children}</Drop>}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
`;

const Drop = styled.div`
  position: absolute;
  right: 0;
  margin-top: 6px;
  background-color: #fff;
  padding: 12px 15px;
  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  z-index: 1;
`;
